import { useEffect, useState } from "react";
import Header from "../../Components/Header";
import SidePanel from "../../Components/SidePanel";
import CreateUniversityWebDetails from "./CreateUniversityWebDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  LIST_UNIVERSITY_WEB_DETAILS,
  UNIVERSITY_WEB_DETAILS_DELETE,
  UNIVERSITY_WEB_DETAILS_DELETE_RESET,
} from "../../Actions/universityWebDetailsAction";
import UniversityWebDetailsTable from "./UniversityWebDetailsTable";
import Loader from "../../Components/Loader";
import UniversityWebDetailsFilter from "./UniversityWebDetailsFilter";
import Search from "../../Components/Search";

export default function UniversityWebDetails() {
  const [hideSidepanel, setHideSidePanel] = useState(true);
  const [FormOpener, setFormOpener] = useState(false);
  const [EditFormOpener, setEditFormOpener] = useState(false);
  const [UniversityWebDetailsList, setUniversityWebDetailsList] = useState([]);
  const [Alert, setAlert] = useState(false);
  const [UniversityWebDetialsEditList, setUniversityWebDetialsEditList] =
    useState({});
  const [
    University_Web_details_SearchName,
    setUniversity_Web_details_SearchName,
  ] = useState("");

  const { LOADING, ERROR, UNIVERSITY_WEB_DETAILS_LISTS } = useSelector(
    (state) => state.LIST_UNIVERSITY_WEB_DETAILS_REDUCER
  );
  const { delete_university_web_Success, delete_university_web_Error } =
    useSelector((state) => state.DELETE_UNIVERSITY_WEB_DETAILS_REDUCER);

  const dispatch = useDispatch();

  const handleHide = (e) => {
    e.preventDefault();
    setHideSidePanel(!hideSidepanel);
  };

  /* handle Searching according to University name start  */
  const handleSearch_data = (e) => {
    if (e.target.value === "" || e.target.value === null) {
      setUniversityWebDetailsList(UNIVERSITY_WEB_DETAILS_LISTS);
    } else {
      setUniversity_Web_details_SearchName(e.target.value);
      console.log(e.target.value);
    }
  };

  const handleUniversityWebDetails_Search_data = async () => {
    const new_universityWeb_details = UniversityWebDetailsList?.filter((el) =>
      el.University_Name?.toLowerCase().includes(
        University_Web_details_SearchName?.toLowerCase()
      )
    );
    setUniversityWebDetailsList(new_universityWeb_details);
  };

  const handleUniversityWebDetailsSearching = (e) => {
    e.preventDefault();
    handleUniversityWebDetails_Search_data();
  };
  const handleKey = (e) => {
    if (e.key === "Enter") {
      handleUniversityWebDetails_Search_data();
    }
  };
  /* handle Searching according to University name End  */

  const handleEditUniversityWebDetails = (data, Edit_data) => {
    setUniversityWebDetialsEditList(Edit_data);
    handleEditorForm();
  };

  const handleFormClose = () => {
    setFormOpener(!FormOpener);
  };

  const handleEditorForm = () => {
    setEditFormOpener(!EditFormOpener);
  };

  const University_Web_Details_Get_Req = () => {
    dispatch(LIST_UNIVERSITY_WEB_DETAILS());
  };

  const handleDeleteUniversityWebDetails = (ID) => {
    dispatch(UNIVERSITY_WEB_DETAILS_DELETE(ID));
  };

  useEffect(() => {
    University_Web_Details_Get_Req();
  }, [delete_university_web_Success]);

  useEffect(() => {
    setUniversityWebDetailsList(UNIVERSITY_WEB_DETAILS_LISTS);
  }, [UNIVERSITY_WEB_DETAILS_LISTS]);

  useEffect(() => {
    if (delete_university_web_Success) {
      setAlert(delete_university_web_Success);
    }
    if (delete_university_web_Error) {
      setAlert(delete_university_web_Error);
    }
    if (delete_university_web_Error || delete_university_web_Success) {
      setTimeout(() => {
        setAlert(false);
        dispatch(UNIVERSITY_WEB_DETAILS_DELETE_RESET());
      }, 2000);
    }
  }, [delete_university_web_Success, delete_university_web_Error]);

  return (
    <>
      <Header Page={"University web Details"} handleHide={handleHide} />
      {/*<!-- top-right search bar -->*/}
      <SidePanel handleHide={handleHide} hide={hideSidepanel} />
      {/*<!-- Pushable content along with off-canvas opener. -->*/}
      <div className="bs-offset-main bs-canvas-anim">
        <div className="content-body">
          {/*<!--Body-content-->*/}

          <div className="container-fluid">
            <div className="heading-title">
              <div className="row">
                <div className="col-md-12">
                  <div className="home-table-search">
                    {/* University Web Details Search  */}
                    <Search
                      handleSearch={handleSearch_data}
                      handleSearching={handleUniversityWebDetailsSearching}
                      handleKey={handleKey}
                      SearchData={University_Web_details_SearchName}
                      placeholder={"Search University Name"}
                    />
                    <div className="right-click Create-btn">
                      <a
                        href="#"
                        className="btn create-contact"
                        onClick={() => handleFormClose()}>
                        Create University Web Details
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {Alert && (
              <div className="side_drawer">
                <div
                  className={
                    delete_university_web_Success ? "Alert2" : "Alert3"
                  }>
                  <span onClick={() => setAlert(false)} className="close">
                    &times;
                  </span>
                  <p>{Alert}</p>
                </div>
              </div>
            )}
            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search Contacts..."
                    />
                    <i className="fas fa-filter mob-nav-open"></i>
                  </div>
                  {/*<!-- /filter-in-mob-view -->*/}
                  <UniversityWebDetailsFilter />
                </div>
                {/*<!-- University web Details Table -->*/}
                {LOADING ? (
                  <div>
                    <Loader />
                  </div>
                ) : ERROR ? (
                  <div>
                    <img
                      className="No_data"
                      src="./assets/img/NoRecord.png"
                      alt="data_notfound"
                    />
                  </div>
                ) : (
                  <UniversityWebDetailsTable
                    setUniversityWebDetailsList={setUniversityWebDetailsList}
                    handleEditUniversityWebDetails={
                      handleEditUniversityWebDetails
                    }
                    handleDeleteUniversityWebDetails={
                      handleDeleteUniversityWebDetails
                    }
                    University_Web_Details_Get_Req={
                      University_Web_Details_Get_Req
                    }
                    UniversityWebDetailsList={UniversityWebDetailsList}
                    LOADING={LOADING}
                  />
                )}
              </div>
            </div>
            <CreateUniversityWebDetails
              University_Web_Details_Get_Req={University_Web_Details_Get_Req}
              UniversityWebDetialsEditList={UniversityWebDetialsEditList}
              setUniversityWebDetialsEditList={setUniversityWebDetialsEditList}
              handleEditorForm={handleEditorForm}
              EditFormOpener={EditFormOpener}
              FormOpener={FormOpener}
              handleFormClose={handleFormClose}
            />
            {/*<!--/overlay-Create-contact-->*/}
          </div>
        </div>
      </div>
    </>
  );
}
